import React, { useContext, useState } from 'react';
import { Form, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { routerPath } from '../../router/routerPath';
import { login } from '../../store/authStore/auth.action';
import { authContext } from '../../store/authStore/AuthContext';
import { CustomButton, FormInput } from '../../styles/styled';
import { LoginCheckbox, LoginForm, PopupBlock } from './styled';
import { AuthTokenResponse } from './types';

type LoginPasswordType = {
  username: string;
  password: string;
};

export const LoginPopup = () => {
  const navigate = useNavigate();
  const { dispatch } = useContext(authContext);
  const [loginInput, setLoginInput] = useState<LoginPasswordType>({
    username: '',
    password: '',
  });

  const authorizationFunc = async (usernamePassword: LoginPasswordType) => {
    try {
      const response = await api.post<AuthTokenResponse>(endpoints.login(), usernamePassword);

      if (response.status === 200) {
        dispatch(login(response.data.token, response.data.roles));
        if (response.data.roles.includes('ROLE_SUPER_FEDERAL')) navigate(routerPath.application);
        else if (response.data.roles.includes('ROLE_FEDERAL')) navigate(routerPath.application);
        else if (response.data.roles.includes('ROLE_EXPERT_POVS') || response.data.roles.includes('ROLE_POVS'))
          navigate(routerPath.povsLk);
        else if (response.data.roles.includes('ROLE_REPRESENTATIVE')) navigate(routerPath.representativeProfile);
        else if (response.data.roles.includes('ROLE_NMS_MEMBER')) navigate(routerPath.nmsProfile);
        else if (response.data.roles.includes('ROLE_EXPERT')) navigate(routerPath.expertUserProfile);
        else navigate(routerPath.home);
      }
    } catch (err) {
      message.error('Не удалось авторизоваться');
    }
  };

  return (
    <PopupBlock>
      <div className="title">Авторизация</div>
      <LoginForm>
        <Form onFinish={() => authorizationFunc(loginInput)}>
          <Form.Item>
            <div className="text">Логин (email)</div>
            <FormInput
              onChange={(e) =>
                setLoginInput({
                  ...loginInput,
                  username: e.target.value,
                })
              }
            />
          </Form.Item>
          <Form.Item>
            <div className="text">Пароль</div>
            <FormInput.Password
              onChange={(e) =>
                setLoginInput({
                  ...loginInput,
                  password: e.target.value,
                })
              }
            />
          </Form.Item>
          <Form.Item>
            <LoginCheckbox>Запомнить меня</LoginCheckbox>
          </Form.Item>
          <Form.Item style={{ display: 'flex', justifyContent: 'center' }}>
            <CustomButton>Войти</CustomButton>
          </Form.Item>
        </Form>
      </LoginForm>
    </PopupBlock>
  );
};
